// extracted by mini-css-extract-plugin
module.exports = {"addClientsContainer":"Clients_addClientsContainer__3FQI_","addClientsRow":"Clients_addClientsRow__1CKzq"};